var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 26,
    viewBox: "0 0 90 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6615 9.13731C37.9263 8.47798 36.3695 7.60717 34.1146 7.60717C32.5392 7.60717 30.9206 8.1732 30.9206 9.72822C30.9206 11.3143 32.9531 11.3952 34.9424 11.5072C37.0861 11.6565 40.5458 11.8679 40.5458 15.177C40.5458 18.0507 38.0067 19.2076 35.0598 19.2076C31.9399 19.2076 29.9506 17.9014 28.6162 16.6761L29.6109 15.5378C30.6426 16.5019 32.3539 17.8081 35.0969 17.8081C37.185 17.8081 38.9086 17.0493 38.9086 15.3885C38.9086 13.5349 37.0305 13.2488 34.9424 13.0995C32.2921 12.9316 29.2834 12.7387 29.2834 9.88372C29.2834 7.06602 31.9708 6.21387 34.1702 6.21387C36.7093 6.21387 38.6986 7.23396 39.6376 8.01147L38.6615 9.13731Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2609 17.746C57.1336 17.746 59.3886 15.4757 59.3886 12.6767C59.3886 9.91494 57.1336 7.66327 54.2609 7.66327C51.3882 7.66327 49.1703 9.91494 49.1703 12.6767C49.1641 15.4757 51.382 17.746 54.2609 17.746ZM54.2609 6.20776C58.0541 6.20776 61.0998 9.10011 61.0998 12.6767C61.0998 16.3092 58.0541 19.2015 54.2609 19.2015C50.4429 19.2015 47.459 16.3092 47.459 12.6767C47.4528 9.10011 50.4429 6.20776 54.2609 6.20776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3793 6.5249H69.7422V18.878H71.3793V6.5249Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.253 6.5249V17.4287H90.0002V18.8842H80.6221V6.5249H82.253Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05066 0C7.62974 0.808612 0 5.00718 0 5.00718V9.45455L8.61203 14.4928V26H10.9905V13.2239L2.39703 8.22919V6.20144L9.05066 2.50048C16.3097 6.51866 17.1314 6.97273 17.1314 6.97273V4.46603C13.7521 2.61866 9.05066 0 9.05066 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03823 5.94019L6.57324 7.30239L15.1111 12.0297V16.0354L13.4307 16.7258V19.4689C14.4625 18.8966 15.6177 18.4986 17.1313 17.6651V13.9952V10.4187C14.2648 8.83253 9.03823 5.94019 9.03823 5.94019Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00585938 13.3296L0.0120373 16.0789L6.122 19.4688V16.7382L0.00585938 13.3296Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4ab53d9b93bf3bf2d1a8662784708358.svg";
export { ForwardRef as ReactComponent };